import React, { useCallback, FormEvent, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSetup } from 'hooks/useSetup/useSetup';
import { CheckField } from 'ui/shared/controls';
import { LoadingSpinner } from 'ui/shared/LoadingSpinner';
import { ErrorMessage } from 'ui/shared/messages';
import { SetupDeviceGroup } from '../setupDeviceGroup/SetupDeviceGroup';

require('./SetupElevatorPanel.css');

export const SetupElevatorPanel = () => {
    const { t } = useTranslation();
    const { group, busy, finish, errorMessage } = useSetup();

    const groupId = group && group.id;

    const [ externalId, setExternalId ] = useState('');
    const [ lastElevator, setLastElevator ] = useState(false);

    const handleSubmit = useCallback((e: FormEvent<HTMLFormElement>) => {
        finish(externalId, lastElevator);
        e.preventDefault();
        return false;
    }, [ externalId, lastElevator, finish ]);

    // Reset the external IDs if the group changes
    useEffect(() => {
        setExternalId('');
        setLastElevator(false);
    }, [ groupId, setExternalId, setLastElevator ]);

    return (
        <div id="setup-elevator-panel" className="setup-panel">
            <h2>
                { t('SETUP.ELEVATOR_DETAILS') }
            </h2>
            <form
                className="ui form"
                onSubmit={ handleSubmit }
            >
                <SetupDeviceGroup
                    enabled={ !!group }
                    externalId={ externalId }
                    changeExternalId={ setExternalId }
                />

                <CheckField
                    id="last-elevator"
                    disabled={ busy || !group }
                    input={ {
                        checked: lastElevator,
                        onChange: (e: FormEvent<HTMLInputElement>) => setLastElevator(e.currentTarget.checked),
                    } }
                    labelKey="SETUP.LAST_ELEVATOR"
                />

                <button
                    id="setup-elevator-next"
                    className="ui default red button"
                    type="submit"
                    disabled={ busy || !group }
                >
                    { t('COMMAND.FINISH') }
                </button>
                { busy &&
                    <LoadingSpinner size="small"/>
                }
            </form>
            <ErrorMessage message={ errorMessage }/>
        </div>
    );
};
